module.exports = __webpack_public_path__ + "img/luis-losi-sa.1b384c35.jpg";